import { render, staticRenderFns } from "./BatchUpdatePrices.vue?vue&type=template&id=133bef27&"
import script from "./BatchUpdatePrices.vue?vue&type=script&lang=js&"
export * from "./BatchUpdatePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports